<template>
  <v-card>
    <v-btn
      icon
      style="position: absolute; right: 10px; top: 10px;"
      @click="$emit('close')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-card-subtitle class="pb-0 secondary--text">
      {{ selectedStore.type }}
    </v-card-subtitle>
    <v-card-title class="pt-0">{{ selectedStore.title }}</v-card-title>

    <v-divider></v-divider>

    <v-card-text class="px-0">
      <v-row>
        <v-col class="py-0">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="accent">mdi-map-marker</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="py-1">
                <v-list-item-title>
                  {{ selectedStore.address }}
                </v-list-item-title>
                <v-list-item-subtitle>Dirección</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="accent">mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="py-1">
                <v-list-item-title>{{ selectedStore.phone }}</v-list-item-title>
                <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <v-col class="d-flex justify-center align-center">
          <v-btn
            class="mr-2"
            color="green"
            dark
            fab
            @click="$emit('openCallDialog', selectedStore)"
          >
            <v-icon>mdi-phone</v-icon>
          </v-btn>
          <v-btn
            v-if="selectedStore.phone.length == 10"
            color="#075E54"
            dark
            fab
            @click="goToWhatsApp()"
          >
            <v-icon>mdi-whatsapp</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StoreInfo",

  props: ["selectedStore"],

  methods: {
    goToWhatsApp() {
      window.open(
        `https://wa.me/57${this.selectedStore.phone}?text=Hola, ¿cómo estás? ¿${this.selectedStore.title}? Te encontré en *Directorio Fontumi* y quiero pedir un domicilio.`,
        "_blank"
      );
    }
  }
};
</script>
